import { Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from '../style/gstheme';
import withGS from '../withGShoc';

const styles = () => {
  return Object.assign({
    sparqlProjectCard: {
      display: 'flex',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      minHeight: 40,
      paddingTop: 18

    }
  }, globalStyles);
};

class SparqlProjectCard extends React.Component {

  render() {

    const { classes, data, compact } = this.props;
    const title = data && data.title ?
      data.title[data.defaultLang]
      :
      'Title not available';
    const defaultLang = data.defaultLang ? data.defaultLang : '';
    const langDisplay = defaultLang === "und" ? "None" : defaultLang;

    return (
      <div data-test="sparql-project"
        className={classes.sparqlProjectCard}
        style={compact ?
          {
            height: 'auto',
            paddingTop: 4,
            paddingBottom: 0
          }
          :
          {}
        }>
        <div style={{ flex: 0, marginLeft: compact ? 0 : 12 }}>
          <Avatar data-test="list-avatar-language"
            className={defaultLang.length > 2 ? classes.wideSmallPrimaryAvatar : classes.smallPrimaryAvatar}
            style={{
              transform: 'translateY(-4px)'
            }}>
            {langDisplay}
          </Avatar>
        </div>
        <div style={{ flex: 1, marginLeft: 12 }}>
          <Typography data-test={data._notAvailable ? "sparql-project-title-unavailable" : "sparql-project-title"}
            className={classes.subHeading}
            style={{
              ...(data._notAvailable) && { color: '#CA4F0C' }
            }}>
            {title}
          </Typography>
          {data.pendingDeletion && <Typography data-test="pending-deletion" variant="caption" style={{color: '#DD2C00'}}>This is pending deletion</Typography> }
        </div>
      </div>
    );
  }
}

SparqlProjectCard.defaultProps = {
  compact: false
};

SparqlProjectCard.propTypes = {
  classes: PropTypes.object,
  compact: PropTypes.bool,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(SparqlProjectCard));